import request from '@/utils/index'

export function getGiftInfo (data, token) {
  return request({
    url: 'https://production.motorjourney.cn/v1/integral/gift/info',
    method: 'get',
    params: data,
    headers: { 'x-api-key': token }
  })
}
